import React from 'react';

import { CartHandoffModal } from '@order/features-cart-handoff';

// ─────────────────────────────────────────────────────────────────────────────

export const CartHandoffScreen = () => {
  return <CartHandoffModal />;
};
